import React from "react";
import { Link } from "react-router-dom";
import IntroVideo from '../videos/Axis_background.mp4';
import VideoComponent from './VideoComponent.js';
import Axis_Logo from '../images/Axis_image6.png';
import PageSEO from "../components/seo/PageSEO";
import { useScrollBehavior } from './useScrollBehavior.js'; 
import "../styles/home.css";

export default function Home() {

  useScrollBehavior();

  return (
    <main className="home">
      <PageSEO
        title="Your App Name | Connect • Share • Discover"
        description="A modern social platform with posts, DMs, community updates, and admin news."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "The Axis",
          "url": (process.env.REACT_APP_SITE_URL || "") + "/"
        }}
      />
     
      <div className="home__bg" aria-hidden="true">
         <VideoComponent  videoSrc={IntroVideo} />
        {/*<video className="home__video" autoPlay muted loop playsInline>
          <source src="/videos/Axis_background.mp4" type="video/mp4" />
        </video>*/}
        {/*<div className="home__overlay" />*/}
      </div>
        
      <section className="home__content">

        <div  className="module" id="home__top">
          <div className='home__logo '>
            <img src={Axis_Logo} alt="Axis_logo" className="axis_logo" />
          </div>
          <h1 className="home__title">The Axis</h1>
          {/*<h3 className="home__title2">Life Through The Sacred Three</h3>*/}
          <h3 className="home__title2">Change Yourself - Change the World.</h3>
          <p className="home__subtitle">Life • The Planet • The Social Contract</p>
          <p className="home__copy">
           Discover the philosophy, explore the book, join the organization and experience the platform built to apply the principles of the sacred three to modern life and technology.
          </p>

          <div className="home__cta">
            <Link className="btn btn--primary" to="/join">Join the Axis</Link>
            <Link className="btn btn--ghost" to="/book">Get the Book</Link>
            <Link className="btn btn--ghost" to="/contact">Contact</Link>
          </div>

          <div className="home__micro">
            <div className="pill"></div>
            <div className="pill"></div>
            <div className="pill"></div>
            <div className="pill"></div>
          </div>
        </div>

        {/*<div className="module" id="home_bottom">
          <div className="panel">
            <div className="panel__title">Welcome to the Axis</div>
            <div className="panel__body">
              <div className="panel__row">
                <div className="panel__label">This is a label</div>
                <div className="panel__value">Ths is stuff inside said label</div>
              </div>
              <div className="panel__row">
                <div className="panel__label">This is another label</div>
                <div className="panel__value">and more stuff inside the label</div>
              </div>
              <div className="panel__row">
                <div className="panel__label">Why are there so many labels</div>
                <div className="panel__value">And why is there so much content </div>
              </div>
              
            </div>
            <div className="panel__cta">
                <Link className="btn btn--primary" to="/blog">Read the Blog</Link>
              </div>
          </div>
        </div>*/}
                {/* ── THREE PILLARS ── */}
        <div className="module" id="home__pillars">
          <div id="module__heading_div1">
            <h2 className="module__heading">The Sacred Three</h2>
            <p className="module__subheading">
              Every decision, every interaction, every system — inspired by the sacred three
              .
            </p>
            <p className="module__subheading">
                We hold three things sacred: life, the planet that sustains it, and the
                social contract. Their destruction is not inevitable — but it is well
                underway, and it will not be stopped by those who profit from it. It will
                be stopped by people who see clearly and act.
            </p>
          </div>
          <div className="pillars__grid">
            <div className="pillar">
              <div className="pillar__icon" aria-hidden="true">
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2"/>
                  <path d="M24 14c0 0-8 6-8 12a8 8 0 0016 0c0-6-8-12-8-12z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                  <line x1="24" y1="34" x2="24" y2="38" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="pillar__title">Life</h3>
              <p className="pillar__body">
                Reverence for all living things. Decisions that honour the sanctity
                of existence — human, animal, and ecological — form the first axis
                of ethical thought.
              </p>
            </div>
 
            <div className="pillar">
              <div className="pillar__icon" aria-hidden="true">
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 6C14 6 6 14 6 24s8 18 18 18 18-8 18-18S34 6 24 6z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M6 24h36M24 6c-4 4-6 10-6 18s2 14 6 18M24 6c4 4 6 10 6 18s-2 14-6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="pillar__title">The Planet</h3>
              <p className="pillar__body">
                The natural world is not a resource to be consumed but a system to
                be sustained. Environmental responsibility is woven into every layer
                of the Axis philosophy.
              </p>
            </div>
 
            <div className="pillar">
              <div className="pillar__icon" aria-hidden="true">
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="18" r="6" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="32" cy="18" r="6" stroke="currentColor" strokeWidth="2"/>
                  <path d="M4 38c0-6.627 5.373-10 12-10M44 38c0-6.627-5.373-10-12-10M24 38c0-6.627 2.686-10 0-10s0 3.373 0 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M20 28c1.2-.6 2.5-.9 4-.9s2.8.3 4 .9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="pillar__title">Social Contract</h3>
              <p className="pillar__body">
                We exist in relation to one another. The Social Contract is the
                invisible architecture of trust, mutual obligation, and shared
                responsibility that makes civilisation possible.
              </p>
            </div>
          </div>
        </div>
 
        {/* ── ABOUT / PHILOSOPHY ── */}
        <div className="module" id="home__about">
          <div className="about__split">
            <div className="about__text">
              <span className="about__eyebrow">Our Mission</span>
              <h2 className="about__heading">To Change the World<br />by Changing Ourselves</h2>
              <p className="about__body">
                The Axis is more than a platform — it is a coherent way of seeing
                the world. Rooted in centuries of moral philosophy yet urgently
                relevant to the crises of modern life, it provides a shared language
                for people who believe that how we treat each other and our planet
                matters profoundly.
              </p>
              <p className="about__body">
                Whether navigating personal decisions, engaging in public discourse,
                or building technology, the Axis offers a consistent ethical centre
                — a true axis — around which principled action can revolve.
                <br></br>
                <br></br>
                <ul>
                  <p><strong>First, to change ourselves</strong> — to become conscious of the three and to live accordingly.</p>
                  <p><strong>Second, to act</strong> — because awareness without action is surrender.</p>
                  <p><strong>Third, to organize</strong> — because no one acts alone for long.</p> 
                  <p><strong>Fourth, to act as one</strong> — to become a force capable of protecting what is sacred.</p>
                </ul>
              </p>
              <Link className="btn btn--primary" to="/book">Explore the Philosophy</Link>
            </div>
            <div className="about__stats">
              <div className="stat">
                <span className="stat__number">3</span>
                <span className="stat__label">sacred objects</span>
              </div>
              <div className="stat">
                <span className="stat__number">∞</span>
                <span className="stat__label">Applications</span>
              </div>
              <div className="stat">
                <span className="stat__number">1</span>
                <span className="stat__label">Shared Purpose</span>
              </div>
            </div>
          </div>
        </div>
 
        {/* ── THE BOOK ── */}
        <div className="module" id="home__book">
          <div className="panel panel--book">
            <div className="panel__title">The Book</div>
            <div className="panel__body">
              <div className="panel__row">
                <div className="panel__label">What It Is</div>
                <div className="panel__value">
                  A deep exploration of the sacred three — Life, The Environment, and
                  The Social Contract — and how they intersect with technology,
                  governance, and daily decision-making.
                </div>
              </div>
              <div className="panel__row">
                <div className="panel__label">Who It's For</div>
                <div className="panel__value">
                  Thinkers, builders, and citizens who believe that ethical clarity
                  is not a luxury but a necessity in an increasingly complex world.
                </div>
              </div>
              <div className="panel__row">
                <div className="panel__label">Why It Matters</div>
                <div className="panel__value">
                  We are living through a period of profound moral disorientation.
                  The Axis offers a stable reference point — a philosophy that is
                  practical, principled, and deeply human.
                </div>
              </div>
            </div>
            <div className="panel__cta">
              <Link className="btn btn--primary" to="/book">Get the Book</Link>
              <Link className="btn btn--ghost" to="/blog">Read the Blog</Link>
            </div>
          </div>
        </div>
 
        {/* ── THE APP ── */}
        <div className="module" id="home__app">
          <h2 className="module__heading">The Platform</h2>
          <p className="module__subheading">
            Ethics in action. The Axis app is a social platform designed from the
            ground up with the three pillars built into every feature.
          </p>
          <div className="features__grid">
            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 6h24v20H4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                  <path d="M8 11h16M8 16h10M8 21h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Posts & Discourse</h4>
              <p className="feature__body">
                Share ideas and engage in principled discussion within a community
                guided by the Axis values.
              </p>
            </div>
            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26 6H6a2 2 0 00-2 2v12a2 2 0 002 2h14l6 4V8a2 2 0 00-2-2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Direct Messages</h4>
              <p className="feature__body">
                Private, respectful communication — built on trust and the mutual
                obligations of the Social Contract.
              </p>
            </div>
            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M16 10v6l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Community Updates</h4>
              <p className="feature__body">
                Stay informed with curated news and updates from communities
                committed to the Axis principles.
              </p>
            </div>
            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 4l3.09 6.26L26 11.27l-5 4.87 1.18 6.88L16 19.77l-6.18 3.25L11 16.14 6 11.27l6.91-1.01L16 4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Admin News</h4>
              <p className="feature__body">
                Transparent governance updates from platform administrators —
                accountability as a built-in feature, not an afterthought.
              </p>
            </div>
          </div>
          <div className="home__cta home__cta--centered">
            <Link className="btn btn--primary" to="/app">Download the App</Link>
          </div>
        </div>
 
        {/* ── CLOSING CTA ── */}
        <div className="module" id="home_bottom">
          <div className="panel panel--closing">
            <div className="panel__title">Ready to Begin?</div>
            <div className="panel__body">
              <div className="panel__row">
                <div className="panel__label">Read</div>
                <div className="panel__value">
                  Start with the Codex or the book and lay the philosophical groundwork.
                </div>
              </div>
              <div className="panel__row">
                <div className="panel__label">Connect</div>
                <div className="panel__value">
                  Join the organization and the platform and engage with a community of principled thinkers.
                </div>
              </div>
              <div className="panel__row">
                <div className="panel__label">Apply</div>
                <div className="panel__value">
                  Bring the sacred three into your daily decisions, work, and relationships.
                </div>
              </div>
            </div>
            <div className="panel__cta">
              <Link className="btn btn--primary" to="/app">Get the App</Link>
              <Link className="btn btn--ghost" to="/book">Get the Book</Link>
              <Link className="btn btn--ghost" to="/blog">Read the Blog</Link>
            </div>
          </div>
        </div>

      </section>
    </main>
  );
}
